import {
    ALL_METRICS,
    META_METRICS,
    GOOGLE_METRICS,
    TIKTOK_METRICS,
    LINKEDIN_METRICS,
    PROPERTIES_FOR_METRIC,
    METRIC_TYPE_CURRENCY,
    METRIC_TYPE_INTEGER,
    METRIC_TYPE_DECIMAL,
    COST_METRIC_NAME,
    CLICKS_METRIC_NAME,
    CONVERSIONS_METRIC_NAME,
    IMPRESSIONS_METRIC_NAME,
    CPC_METRIC_NAME,
    CTR_METRIC_NAME,
    CPM_METRIC_NAME,
    CPA_METRIC_NAME,
    PURCHASES_VALUE_METRIC_NAME,
    ROAS_METRIC_NAME,
    ACOS_METRIC_NAME,
    CONVERSION_RATE_METRIC_NAME,
    GA4_SESSIONS_METRIC_NAME,
    GA4_ACTIVE_USERS_METRIC_NAME,
    GA4_CONVERSIONS_METRIC_NAME,
    GA4_ECOMMERCE_PURCHASES_METRIC_NAME,
    GA4_PURCHASE_REVENUE_METRIC_NAME,
    GA4_ROAS_METRIC_NAME,
    GA4_ACOS_METRIC_NAME,
    GA4_CPA_METRIC_NAME,
    ECOMMERCE_SESSIONS_METRIC_NAME,
    ECOMMERCE_GROSS_REVENUE_METRIC_NAME,
    ECOMMERCE_ORDERS_METRIC_NAME,
    ECOMMERCE_AVG_GROSS_ORDER_VALUE_METRIC_NAME,
    ECOMMERCE_ROAS_METRIC_NAME,
    ECOMMERCE_ACOS_METRIC_NAME,
    ECOMMERCE_CONVERTION_RATE_METRIC_NAME,
    ECOMMERCE_CPA_METRIC_NAME,
    META_VIDEO_VIEW_3S_RATE_METRIC_NAME,
    GOOGLE_SEARCH_IS_METRIC_NAME,
    GOOGLE_SEARCH_TOP_IS_METRIC_NAME,
    GOOGLE_SEARCH_ABS_TOP_IS_METRIC_NAME,
    GOOGLE_SEARCH_LOST_IS_RANK_METRIC_NAME,
    GOOGLE_SEARCH_LOST_IS_BUDGET_METRIC_NAME,
    GOOGLE_VIDEO_QUARTILE_P25_RATE_METRIC_NAME,
    TIKTOK_VIDEO_VIEW_2S_RATE_METRIC_NAME,
    TIKTOK_VIDEO_VIEW_6S_RATE_METRIC_NAME,
    TIKTOK_FREQUENCY_METRIC_NAME,
    META_FREQUENCY_METRIC_NAME,
} from "./metrics";
import {
    ANALYTICS_CHANNEL,
    CHANNEL_INFO_BY_CHANNEL,
    CHANNEL_TYPE_ECOMMERCE,
    FACEBOOK_CHANNEL,
    GOOGLE_CHANNEL,
    LINKEDIN_CHANNEL,
    TIKTOK_CHANNEL,
} from "../channels/channels";

export const METRIC_GROUP_GENERAL = 'GENERAL';
export const METRIC_GROUP_GOOGLE = 'GOOGLE';
export const METRIC_GROUP_META = 'META';
export const METRIC_GROUP_TIKTOK = 'TIKTOK';
export const METRIC_GROUP_LINKEDIN = 'LINKEDIN';
export const METRIC_GROUP_GA4 = 'GA4';
export const METRIC_GROUP_ECOMMERCE = 'ECOMMERCE';
export const METRIC_GROUP_CUSTOM = 'CUSTOM';
// «De la línea» (Centro de Alertas v2): los números que el Tablero calcula por línea (% del presupuesto
// invertido, desvío del ritmo, del objetivo…). Sólo existe donde quien monta el selector pasa `lineMetrics`
// (el constructor de alertas): no está en `METRIC_GROUPS_ORDER`, así que ninguna otra pantalla la ofrece.
export const METRIC_GROUP_LINE = 'LINE';

export const METRIC_GROUPS_ORDER = [
    METRIC_GROUP_GENERAL,
    METRIC_GROUP_GOOGLE,
    METRIC_GROUP_META,
    METRIC_GROUP_TIKTOK,
    METRIC_GROUP_LINKEDIN,
    METRIC_GROUP_GA4,
    METRIC_GROUP_ECOMMERCE,
];

const GENERAL_METRICS = [
    COST_METRIC_NAME, CLICKS_METRIC_NAME, IMPRESSIONS_METRIC_NAME, CONVERSIONS_METRIC_NAME,
    CPC_METRIC_NAME, CTR_METRIC_NAME, CPM_METRIC_NAME, CPA_METRIC_NAME,
    PURCHASES_VALUE_METRIC_NAME, ROAS_METRIC_NAME, ACOS_METRIC_NAME, CONVERSION_RATE_METRIC_NAME,
];

const GA4_METRICS = [
    GA4_SESSIONS_METRIC_NAME, GA4_ACTIVE_USERS_METRIC_NAME, GA4_CONVERSIONS_METRIC_NAME,
    GA4_ECOMMERCE_PURCHASES_METRIC_NAME, GA4_PURCHASE_REVENUE_METRIC_NAME,
    GA4_ROAS_METRIC_NAME, GA4_ACOS_METRIC_NAME, GA4_CPA_METRIC_NAME,
];

const ECOMMERCE_METRICS = [
    ECOMMERCE_SESSIONS_METRIC_NAME, ECOMMERCE_GROSS_REVENUE_METRIC_NAME,
    ECOMMERCE_ORDERS_METRIC_NAME, ECOMMERCE_AVG_GROSS_ORDER_VALUE_METRIC_NAME,
    ECOMMERCE_ROAS_METRIC_NAME, ECOMMERCE_ACOS_METRIC_NAME,
    ECOMMERCE_CONVERTION_RATE_METRIC_NAME, ECOMMERCE_CPA_METRIC_NAME,
];

export const METRIC_GROUP_INFO = {
    [METRIC_GROUP_GENERAL]: {
        i18nKey: 'goal_configuration.metric_select.group.general',
        defaultLabel: 'General',
        iconPrefix: 'fas',
        iconName: 'chart-line',
        color: '#4A4A4A',
        members: GENERAL_METRICS,
        suffix: null,
    },
    [METRIC_GROUP_GOOGLE]: {
        i18nKey: 'goal_configuration.metric_select.group.google',
        defaultLabel: 'Google Ads',
        iconPrefix: 'fab',
        iconName: 'google',
        color: '#1AA85D',
        members: GOOGLE_METRICS,
        suffix: ' (Google)',
    },
    [METRIC_GROUP_META]: {
        i18nKey: 'goal_configuration.metric_select.group.meta',
        defaultLabel: 'Meta',
        iconPrefix: 'fab',
        iconName: 'meta',
        color: '#3B5998',
        members: META_METRICS,
        suffix: null,
    },
    [METRIC_GROUP_TIKTOK]: {
        i18nKey: 'goal_configuration.metric_select.group.tiktok',
        defaultLabel: 'TikTok',
        iconPrefix: 'fab',
        iconName: 'tiktok',
        color: '#000000',
        members: TIKTOK_METRICS,
        suffix: ' (TikTok)',
    },
    // LinkedIn no tiene columnas fijas (card AxXYBhPm): este grupo es la única puerta para sumar
    // sus métricas como columna propia o como objetivo.
    [METRIC_GROUP_LINKEDIN]: {
        i18nKey: 'goal_configuration.metric_select.group.linkedin',
        defaultLabel: 'LinkedIn',
        iconPrefix: 'fab',
        iconName: 'linkedin',
        color: '#0A66C2',
        members: LINKEDIN_METRICS,
        suffix: ' (LinkedIn)',
    },
    [METRIC_GROUP_GA4]: {
        i18nKey: 'goal_configuration.metric_select.group.ga4',
        defaultLabel: 'GA4',
        iconPrefix: 'fas',
        iconName: 'chart-bar',
        color: '#E7B042',
        members: GA4_METRICS,
        suffix: ' (GA4)',
    },
    [METRIC_GROUP_ECOMMERCE]: {
        i18nKey: 'goal_configuration.metric_select.group.ecommerce',
        defaultLabel: 'Ecommerce',
        iconPrefix: 'fas',
        iconName: 'shopping-bag',
        color: '#96BF48',
        members: ECOMMERCE_METRICS,
        suffix: ' (Ecommerce)',
    },
    [METRIC_GROUP_CUSTOM]: {
        i18nKey: 'goal_configuration.metric_select.group.custom',
        defaultLabel: 'Mis métricas',
        iconPrefix: 'fas',
        iconName: 'wand-magic-sparkles',
        color: '#FF470F',
        members: [],
        suffix: null,
    },
    [METRIC_GROUP_LINE]: {
        i18nKey: 'alerts_center.builder.metric_group_line',
        defaultLabel: 'De la línea',
        iconPrefix: 'fas',
        iconName: 'gauge-high',
        color: '#440631',
        members: [],
        suffix: null,
    },
};

export const SUGGESTED_METRICS = [
    COST_METRIC_NAME, CLICKS_METRIC_NAME, IMPRESSIONS_METRIC_NAME, CONVERSIONS_METRIC_NAME,
    CPA_METRIC_NAME, ROAS_METRIC_NAME, CTR_METRIC_NAME,
];

const METRIC_TO_GROUP_INDEX = (() => {
    const map = {};
    METRIC_GROUPS_ORDER.forEach((groupKey) => {
        METRIC_GROUP_INFO[groupKey].members.forEach((metricName) => {
            map[metricName] = groupKey;
        });
    });
    return map;
})();

export function getGroupForMetric(metricName) {
    return METRIC_TO_GROUP_INDEX[metricName] || METRIC_GROUP_GENERAL;
}

// Métricas DECIMAL que son ratios/porcentajes (se renderizan con badge "%").
const RATIO_METRICS = new Set([
    CTR_METRIC_NAME, ROAS_METRIC_NAME, ACOS_METRIC_NAME, CONVERSION_RATE_METRIC_NAME,
    GA4_ROAS_METRIC_NAME, GA4_ACOS_METRIC_NAME,
    ECOMMERCE_ROAS_METRIC_NAME, ECOMMERCE_ACOS_METRIC_NAME, ECOMMERCE_CONVERTION_RATE_METRIC_NAME,
    META_VIDEO_VIEW_3S_RATE_METRIC_NAME,
    GOOGLE_SEARCH_IS_METRIC_NAME, GOOGLE_SEARCH_TOP_IS_METRIC_NAME, GOOGLE_SEARCH_ABS_TOP_IS_METRIC_NAME,
    GOOGLE_SEARCH_LOST_IS_RANK_METRIC_NAME, GOOGLE_SEARCH_LOST_IS_BUDGET_METRIC_NAME,
    GOOGLE_VIDEO_QUARTILE_P25_RATE_METRIC_NAME,
    TIKTOK_VIDEO_VIEW_2S_RATE_METRIC_NAME, TIKTOK_VIDEO_VIEW_6S_RATE_METRIC_NAME,
]);

// Frequency es DECIMAL pero conceptualmente count-per-user (1.5 impresiones/persona);
// va con badge "#" para no sugerir que es porcentaje.
const DECIMAL_COUNT_METRICS = new Set([
    META_FREQUENCY_METRIC_NAME, TIKTOK_FREQUENCY_METRIC_NAME,
]);

export function getValueTypeBadge(metricName) {
    const props = PROPERTIES_FOR_METRIC[metricName];
    if (!props) return '#';
    if (RATIO_METRICS.has(metricName)) return '%';
    if (props.Type === METRIC_TYPE_CURRENCY) return '$';
    if (props.Type === METRIC_TYPE_INTEGER) return '#';
    if (props.Type === METRIC_TYPE_DECIMAL) {
        if (DECIMAL_COUNT_METRICS.has(metricName)) return '#';
        // Para DECIMAL no-categorizado: si el label contiene "%" o "Rate", asumimos %.
        const label = props.Spanish || '';
        if (label.includes('%') || /\brate\b/i.test(label)) return '%';
        return '#';
    }
    return '#';
}

export function getCleanLabel(metricName, {stripChannelSuffix = true} = {}) {
    const props = PROPERTIES_FOR_METRIC[metricName];
    if (!props) return metricName;
    let label = props.Spanish || metricName;
    if (stripChannelSuffix) {
        const groupKey = getGroupForMetric(metricName);
        const suffix = METRIC_GROUP_INFO[groupKey]?.suffix;
        if (suffix && label.endsWith(suffix)) {
            label = label.slice(0, -suffix.length).trim();
        }
    }
    return label;
}

function normalize(str) {
    if (str === null || str === undefined) return '';
    return str
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
}

/**
 * Índice `metricName -> {reason, suggested_alternative}` de lo que el backend declara no medible.
 * Se arma acá y no en cada item para no recorrer la lista una vez por métrica del catálogo.
 */
function indexUnavailable(unavailableMetrics) {
    const index = {};
    (unavailableMetrics || []).forEach((entry) => {
        if (entry && entry.metric_name) index[entry.metric_name] = entry;
    });
    return index;
}

// El grupo de métricas de cada canal de PLATAFORMA. Los que no están (DV360, Sheet, Search Console)
// no tienen grupo propio: sus métricas son las de «General».
const METRIC_GROUP_BY_CHANNEL = {
    [GOOGLE_CHANNEL]: METRIC_GROUP_GOOGLE,
    [FACEBOOK_CHANNEL]: METRIC_GROUP_META,
    // El agregado del Panel manda Meta como 'FACEBOOK', pero algún payload lo nombra 'META'.
    META: METRIC_GROUP_META,
    [TIKTOK_CHANNEL]: METRIC_GROUP_TIKTOK,
    [LINKEDIN_CHANNEL]: METRIC_GROUP_LINKEDIN,
    [ANALYTICS_CHANNEL]: METRIC_GROUP_GA4,
};

/**
 * Los grupos que corresponden a los canales de UNA línea (card RVO9leLh): una línea sólo de Google
 * no tiene de dónde sacar una métrica de Meta, y el selector le ofrecía las 24. «General» va siempre
 * (son las métricas de todas las plataformas) y las personalizadas no pasan por acá.
 *
 * Devuelve `null` —el catálogo entero, lo de siempre— si no hay canales o si ninguno es conocido:
 * un filtro armado sobre un dato que no entendemos escondería métricas válidas.
 */
export function metricGroupsForChannels(channels) {
    if (!Array.isArray(channels)) return null;
    const known = channels.filter((channel) => CHANNEL_INFO_BY_CHANNEL[channel] || METRIC_GROUP_BY_CHANNEL[channel]);
    if (known.length === 0) return null;

    const groups = new Set([METRIC_GROUP_GENERAL]);
    known.forEach((channel) => {
        if (METRIC_GROUP_BY_CHANNEL[channel]) groups.add(METRIC_GROUP_BY_CHANNEL[channel]);
        if ((CHANNEL_INFO_BY_CHANNEL[channel] || {}).channelType === CHANNEL_TYPE_ECOMMERCE) {
            groups.add(METRIC_GROUP_ECOMMERCE);
        }
    });
    return groups;
}

/**
 * `groupKeys` (opcional): el Set de grupos de plataforma que se ofrecen (`metricGroupsForChannels`).
 * Sin él, todos — el default de las pantallas que no conocen los canales de la línea.
 *
 * `lineMetrics` (opcional, `[{metric_key, display_name}]`): el grupo «De la línea», primero. No depende de
 * los canales (toda línea tiene presupuesto y ritmo), así que `groupKeys` no lo filtra.
 */
export function getMetricGroups({query = '', includeEmptyGroups = false, customMetrics = [], unavailableMetrics = [], groupKeys = null,
                                    lineMetrics = []} = {}) {
    const normalizedQuery = normalize(query).trim();
    const unavailableByName = indexUnavailable(unavailableMetrics);
    const result = [];

    if (lineMetrics && lineMetrics.length > 0) {
        const lineInfo = METRIC_GROUP_INFO[METRIC_GROUP_LINE];
        const lineItems = lineMetrics
            .map((metric) => ({
                metricName: metric.metric_key, label: metric.display_name, fullLabel: metric.display_name, badge: '%', isLine: true,
            }))
            .filter((item) => !normalizedQuery
                || `${normalize(item.label)} ${normalize(item.metricName)} ${normalize(lineInfo.defaultLabel)}`.includes(normalizedQuery));
        if (lineItems.length > 0 || includeEmptyGroups) {
            result.push({groupKey: METRIC_GROUP_LINE, info: lineInfo, items: lineItems});
        }
    }

    if (customMetrics && customMetrics.length > 0) {
        const customInfo = METRIC_GROUP_INFO[METRIC_GROUP_CUSTOM];
        const customItems = customMetrics
            .map((cm) => ({
                metricName: cm.metric_key,
                label: cm.display_name,
                fullLabel: cm.display_name,
                badge: '#',
                isCustom: true,
            }))
            .filter((item) => {
                if (!normalizedQuery) return true;
                const haystack = `${normalize(item.label)} ${normalize(item.metricName)} ${normalize(customInfo.defaultLabel)}`;
                return haystack.includes(normalizedQuery);
            });
        if (customItems.length > 0 || includeEmptyGroups) {
            result.push({groupKey: METRIC_GROUP_CUSTOM, info: customInfo, items: customItems});
        }
    }

    METRIC_GROUPS_ORDER.forEach((groupKey) => {
        if (groupKeys && !groupKeys.has(groupKey)) return;
        const info = METRIC_GROUP_INFO[groupKey];
        const items = info.members
            .filter((metricName) => ALL_METRICS.includes(metricName))
            .map((metricName) => ({
                metricName,
                label: getCleanLabel(metricName),
                fullLabel: PROPERTIES_FOR_METRIC[metricName]?.Spanish || metricName,
                badge: getValueTypeBadge(metricName),
                // Se muestra igual, deshabilitada y con el motivo: si desapareciera sin más, el
                // usuario que la busca no se entera de por qué ni de qué usar en su lugar.
                unavailable: unavailableByName[metricName] || null,
            }))
            .filter((item) => {
                if (!normalizedQuery) return true;
                const haystack = `${normalize(item.label)} ${normalize(item.fullLabel)} ${normalize(item.metricName)} ${normalize(info.defaultLabel)}`;
                return haystack.includes(normalizedQuery);
            });
        if (items.length > 0 || includeEmptyGroups) {
            result.push({groupKey, info, items});
        }
    });

    return result;
}

export function getGroupForMetricWithCustom(metricName, customMetrics = [], lineMetrics = []) {
    if (lineMetrics.some((lm) => lm.metric_key === metricName)) {
        return METRIC_GROUP_LINE;
    }
    if (customMetrics.some((cm) => cm.metric_key === metricName)) {
        return METRIC_GROUP_CUSTOM;
    }
    return getGroupForMetric(metricName);
}

export function getLabelForMetricWithCustom(metricName, customMetrics = [], lineMetrics = []) {
    const own = lineMetrics.find((lm) => lm.metric_key === metricName) || customMetrics.find((cm) => cm.metric_key === metricName);
    if (own) return own.display_name;
    return getCleanLabel(metricName);
}

export function getSuggestedItems(unavailableMetrics = []) {
    const unavailableByName = indexUnavailable(unavailableMetrics);
    return SUGGESTED_METRICS
        .filter((metricName) => ALL_METRICS.includes(metricName))
        .map((metricName) => ({
            metricName,
            label: getCleanLabel(metricName),
            badge: getValueTypeBadge(metricName),
            groupKey: getGroupForMetric(metricName),
            unavailable: unavailableByName[metricName] || null,
        }));
}

export function countMatchingMetrics(query = '', customMetrics = [], unavailableMetrics = [], groupKeys = null, lineMetrics = []) {
    // Cuenta lo ELEGIBLE: el «N métricas» del encabezado promete opciones, y las no medibles se
    // muestran pero no se pueden elegir.
    return getMetricGroups({query, customMetrics, unavailableMetrics, groupKeys, lineMetrics})
        .reduce((acc, g) => acc + g.items.filter((item) => !item.unavailable).length, 0);
}
